/**
 * Public Supabase Client
 * 
 * This client is used for PUBLIC reads (odds, games, analyses) that don't require
 * user authentication. It avoids issues with expired tokens when the app resumes
 * from background, especially on iOS PWA.
 * 
 * Use this for:
 * - Fetching odds data
 * - Reading public game information
 * - Any query that should work without user login
 * 
 * DO NOT use this for:
 * - User-specific data (favorites, settings)
 * - Writes that require authentication
 * - Any operation that needs RLS based on auth.uid()
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ywoxtcjwhzooplrvciqj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3b3h0Y2p3aHpvb3BscnZjaXFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc4OTcxMzQsImV4cCI6MjA3MzQ3MzEzNH0.i49yJ0hC1l3tdIWshzM7KF6jDs4veRVlM7SYea80EdI";

/**
 * Supabase client without session persistence.
 * Always uses anon key, never depends on user tokens.
 */
export const supabasePublic = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  }
});
